module.exports = __webpack_public_path__ + "static/media/ytjh.739bf1c1.jpeg";